import React, { useState } from "react";
import axios from "../api";
import { formatMoneda } from "../utils/formatMoneda";
import { formatFechaSegura } from "../services/formatFechaSegura";
import "../cierreTurno/CierreTurno.css";

const toDateInputValue = (fecha) => {
  if (!fecha) return "";
  const d = new Date(fecha);
  if (isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
};

const mergeDateWithTime = (newDateStr, originalFecha) => {
  if (!newDateStr) return null;
  const orig = originalFecha ? new Date(originalFecha) : new Date();
  const [y, m, d] = newDateStr.split("-").map(Number);
  const hour = orig.getHours();
  const min = orig.getMinutes();
  const sec = orig.getSeconds();
  const pad = (n) => String(n).padStart(2, "0");
  return `${y}-${pad(m)}-${pad(d)}T${pad(hour)}:${pad(min)}:${pad(sec)}`;
};

const AjusteFechaTurnoTable = ({ cierres, recargarTabla }) => {
  const [editandoId, setEditandoId] = useState(null);
  const [fechaInicial, setFechaInicial] = useState("");
  const [fechaFinal, setFechaFinal] = useState("");
  const [guardando, setGuardando] = useState(false);

  const iniciarEdicion = (cierre) => {
    setEditandoId(cierre.id);
    setFechaInicial(toDateInputValue(cierre.fechaInicial));
    setFechaFinal(toDateInputValue(cierre.fechaFinal));
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
  };

  const guardarCambios = async () => {
    if (!editandoId) return;
    setGuardando(true);
    try {
      const payload = {};
      if (fechaInicial) {
        const cierre = cierres.find((c) => c.id === editandoId);
        payload.fechaInicial = mergeDateWithTime(fechaInicial, cierre?.fechaInicial);
      }
      if (fechaFinal) {
        const cierre = cierres.find((c) => c.id === editandoId);
        payload.fechaFinal = mergeDateWithTime(fechaFinal, cierre?.fechaFinal);
      }
      if (Object.keys(payload).length === 0) {
        alert("No hay cambios de fecha para guardar.");
        setGuardando(false);
        return;
      }
      await axios.patch(`/cierre-turno/${editandoId}`, payload);
      alert("Fechas actualizadas correctamente.");
      setEditandoId(null);
      if (recargarTabla) await recargarTabla();
    } catch (error) {
      console.error("Error al guardar:", error);
      alert(error.response?.data?.message || "Error al guardar los cambios.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="table-container">
      <table className="cierre-turno-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Cod.Empleado</th>
            <th>Fecha Inicial</th>
            <th>Fecha Final</th>
            <th>Total</th>
            <th>Reportado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {cierres.map((cierre) => {
            const enEdicion = cierre.id === editandoId;
            return (
              <tr key={cierre.id}>
                <td>{cierre.id}</td>
                <td>{cierre.codEmpleado}</td>
                <td>
                  {enEdicion ? (
                    <input
                      type="date"
                      value={fechaInicial}
                      onChange={(e) => setFechaInicial(e.target.value)}
                    />
                  ) : (
                    formatFechaSegura(cierre.fechaInicial)
                  )}
                </td>
                <td>
                  {enEdicion ? (
                    <input
                      type="date"
                      value={fechaFinal}
                      onChange={(e) => setFechaFinal(e.target.value)}
                    />
                  ) : (
                    formatFechaSegura(cierre.fechaFinal)
                  )}
                </td>
                <td className="valor-monetario">{formatMoneda(cierre.total)}</td>
                <td className="valor-monetario">{formatMoneda(cierre.reportado)}</td>
                <td>
                  {enEdicion ? (
                    <>
                      <button
                        onClick={guardarCambios}
                        className="editar-btn"
                        disabled={guardando}
                      >
                        {guardando ? "Guardando..." : "Guardar"}
                      </button>
                      <button
                        onClick={cancelarEdicion}
                        className="cancelar-btn"
                        disabled={guardando}
                      >
                        Cancelar
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={() => iniciarEdicion(cierre)}
                      className="editar-btn"
                    >
                      Editar fecha
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AjusteFechaTurnoTable;
